import { useEffect, useState } from "react";
import { api, fmtErr, fmtDateTime } from "@/lib/api";
import { RoleBadge } from "@/components/badges";
import { toast } from "sonner";

const ACTION_LABELS = {
  connexion: "Connexion",
  societe_creee: "Société créée",
  societe_suspendue: "Société suspendue",
  societe_reactivee: "Société réactivée",
  utilisateur_cree: "Utilisateur créé",
  utilisateur_active: "Utilisateur activé",
  utilisateur_desactive: "Utilisateur désactivé",
  client_cree: "Client entreprise créé",
  acces_portail_cree: "Accès portail créé",
  acces_portail_relance: "Invitation renvoyée",
  acces_portail_desactive: "Accès portail désactivé",
  categorie_creee: "Catégorie créée",
  categorie_modifiee: "Catégorie modifiée",
  ticket_cree: "Ticket créé",
  reponse_ticket: "Réponse ticket",
  note_interne: "Note interne",
  changement_statut: "Changement de statut",
  ticket_cloture: "Ticket clôturé",
  ticket_rouvert: "Ticket rouvert",
  ticket_reassigne: "Ticket réassigné",
  fichiers_ajoutes: "Fichiers ajoutés",
  ticket_supprime: "Ticket supprimé (corbeille)",
  societe_modifiee: "Société modifiée",
  societe_archivee: "Société archivée",
  modele_categorie_cree: "Modèle de catégorie créé",
  modele_categorie_supprime: "Modèle de catégorie supprimé",
  categories_modele_applique: "Modèle sectoriel appliqué",
  compte_active: "Compte activé",
  ticket_auto_assigne: "Ticket auto-assigné",
  ticket_a_assigner: "Ticket à assigner (aucun éligible)",
  utilisateur_modifie: "Utilisateur modifié",
  utilisateur_supprime: "Utilisateur supprimé",
  mot_de_passe_reinitialise: "Mot de passe réinitialisé",
  client_modifie: "Client entreprise modifié",
  client_archive: "Client entreprise archivé",
  client_restaure: "Client entreprise restauré",
  categorie_supprimee: "Catégorie supprimée",
  email_envoye: "Email envoyé (simulé)",
};

export default function AuditLogsPage() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/audit-logs").then(({ data }) => setLogs(data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  return (
    <div data-testid="audit-logs-page">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Logs & sécurité</h1>
        <p className="mt-1 text-sm text-muted-foreground">Journal d'audit des actions sensibles de la plateforme.</p>
      </div>

      <div className="overflow-x-auto rounded-sm border border-border bg-card">
        <table className="w-full text-sm" data-testid="audit-logs-table">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3 font-semibold">Date</th>
              <th className="px-5 py-3 font-semibold">Action</th>
              <th className="px-5 py-3 font-semibold">Auteur</th>
              <th className="px-5 py-3 font-semibold">Rôle</th>
              <th className="px-5 py-3 font-semibold">Société</th>
              <th className="px-5 py-3 font-semibold">Détail</th>
            </tr>
          </thead>
          <tbody>
            {(logs || []).map((l) => (
              <tr key={l.id} className="border-b border-border last:border-b-0 hover:bg-accent transition-colors duration-200" data-testid={`audit-row-${l.id}`}>
                <td className="whitespace-nowrap px-5 py-3 text-xs text-muted-foreground">{fmtDateTime(l.created_at)}</td>
                <td className="px-5 py-3 font-medium">{ACTION_LABELS[l.action] || l.action}</td>
                <td className="px-5 py-3">{l.actor_name}</td>
                <td className="px-5 py-3"><RoleBadge role={l.actor_role} /></td>
                <td className="px-5 py-3 text-muted-foreground">{l.company_name || "—"}</td>
                <td className="max-w-72 truncate px-5 py-3 text-xs text-muted-foreground">
                  {Object.keys(l.detail || {}).length > 0 ? JSON.stringify(l.detail) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs && logs.length === 0 && <div className="p-10 text-center text-sm text-muted-foreground">Aucun log.</div>}
      </div>
    </div>
  );
}
